import React from 'react';
import ViewReverse from '../../../components/ViewReverse';
import { cn } from '../../../utils/utils';
import { Text } from '../../../components/SecondaryMarket';
import { COLORS, fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import { ReactSVG } from 'react-svg';
import ViewItems from '../../../components/ViewItems';
import { iconFillColor } from '../../../utils/functions';

const InvestorCard = ({ title, description, icon, onPress }) => {
  const { TextWeight } = dynamicfunction();

  return (
    <ViewReverse
      className={cn(
        'p-5 mt-5 border rounded-md bg-white shadow-lg gap-5 cursor-pointer items-center transition-all duration-300 border-transparent group hover:border-blue-500',
      )}
      onClick={onPress}
    >
      <div
        className={cn(
          'h-10 w-10 flex items-center justify-center rounded-full border transition-all duration-300 border-primary-light group-hover:border-blue-500',
        )}
      >
        <ReactSVG src={icon} className='group-hover:hidden' />
        <ReactSVG src={icon} className='hidden group-hover:block' beforeInjection={(svg) => iconFillColor(svg, COLORS.light_blue)} />
      </div>

      <ViewItems className={'gap-0.5'}>
        <Text text={title} className='text-primary-light' weight={TextWeight.bold} />
        <Text text={description} size={fontSizes.h10} />
      </ViewItems>
    </ViewReverse>
  );
};

export default InvestorCard;
